import TrueFalseSelectField from "../../field/TrueFalseSelectField/trueFalseSelectField";

export const BooleanFilter = (props) => {
    const { filterName, filterLabel, searchParams, setSearchParams, } = props;
    const handleChange = (event) => {
        const newSearchParams = new URLSearchParams(searchParams.toString());
        if (event.target.value) {
            newSearchParams.set(event.target.name, event.target.value);
        } else {
            // None - remove the filter
            newSearchParams.delete(event.target.name);
        }
        setSearchParams(newSearchParams);
    };

    return (
        <TrueFalseSelectField
            name={filterName}
            label={filterLabel}
            value={searchParams.get(filterName)}
            onChange={handleChange}
            valuesAsBool={false}
        />
    );
};
